import { Record as record } from 'immutable';

import Address from '../../../../src/records/customer/Address';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import { construct, resolve, fields } from '../../../../src/helpers/LinkMapper';

const addressAdapter = ({ postcode: postCode, ...json }) =>
    Address.fromJSON({ postCode, ...json });

const fieldSchema = {
    id: [ fields.string ],
    title: [ fields.string ],
    firstNames: [ fields.string ],
    surname: [ fields.string ],
    address: [ resolve.with(addressAdapter) ],
    email: [ fields.string ],
    phoneNumber: [ fields.string ],
    bankClaims: [ fields.bool ]
};

export default class DelayRepayCustomer extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(DelayRepayCustomer, json, getResolvers(fieldSchema));
    }

    hasAddress () {
        const { address } = this;
        return address && address.line1 && address.town && address.postCode;
    }
}
